import { render } from "./SlideContent.vue?vue&type=template&id=bd499da2"
import script from "./SlideContent.vue?vue&type=script&lang=js"
export * from "./SlideContent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__